<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      spinner="bar-fade-scale"
      color="#1976d2"
      size="128"
      is-full-screen
    />
    <v-snackbar v-model="showSnackbar" color="black" right>
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackbar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap justify-center>
      <v-flex px-0 xs12 sm12 md12 lg12 xl12 text-center>
        <v-card flat min-height="100vh" elevation="0">
          <v-card-title class="elevation-1">
            <v-spacer></v-spacer>
            <v-flex md2>
              <v-dialog
                :retain-focus="false"
                v-model="dialog"
                persistent
                max-width="800px"
                :key="dialog"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    outlined
                    color="green"
                    width="100%"
                    v-bind="attrs"
                    v-on="on"
                  >
                    Add
                  </v-btn>
                </template>
                <v-card>
                  <v-form v-model="addslider" ref="addcat">
                    <v-card-title>
                      <span class="headline">Add Deals</span>
                    </v-card-title>
                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="12" sm="12" md="12">
                            <v-text-field
                              label="Deal Name"
                              v-model="offerData.offerName"
                            >
                            </v-text-field>
                          </v-col>

                          <v-col cols="12" sm="12" md="12" class="pl-2">
                            <v-text-field
                              type="number"
                              label="Price (₹)"
                              v-model="offerData.amount"
                            >
                            </v-text-field>
                          </v-col>
                          <!-- <v-col cols="12" sm="12" md="12">
                            <ImageComp
                              @stepper="winStepper"
                              :height="'2'"
                              :width="'3'"
                              :heading="'Upload Offer Image '"
                              :componentType="'DealImage'"
                            />
                          </v-col> -->
                        </v-row>
                      </v-container>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" text @click="dialogclose()">
                        Close
                      </v-btn>
                      <v-btn
                        color="blue darken-1"
                        text
                        :disabled="!addslider"
                        @click="add()"
                      >
                        Save
                      </v-btn>
                    </v-card-actions>
                  </v-form>
                </v-card>
              </v-dialog>
            </v-flex>
          </v-card-title>
          <div v-if="offerList.length > 0">
            <v-layout wrap justify-center v-if="offerList.length > 0">
              <v-flex v-for="(item, i) in offerList" :key="i" md6 pa-4>
                <v-card style="line-height: 16px" elevation="0" color="grey">
                  <v-layout wrap pa-10>
                    <v-flex xs6 pt-1 text-left pb-2>
                      <span
                        style="
                          font-size: 18px;
                          color: #000000;
                          font-weight: bold;
                        "
                      >
                        {{ item.offerName }}
                      </span>
                    </v-flex>
                    <v-flex xs6 text-right>
                      <v-btn
                        @click="changeDealStatus(item._id)"
                        v-if="item.status == 'Active'"
                        color="green"
                        dark
                        x-small
                        style="text-transform: none"
                      >
                        Active
                      </v-btn>
                      <v-btn
                        @click="changeDealStatus(item._id)"
                        v-if="item.status == 'Inactive'"
                        color="grey"
                        dark
                        x-small
                        style="text-transform: none"
                      >
                        Inactive
                      </v-btn>
                    </v-flex>

                    <!-- <v-flex md12 px-2 style="border: 3px solid grey">
                      <img
                        v-if="item.photo"
                        v-viewer
                        style="
                          width: 100%;
                          object-fit: contain;
                          cursor: pointer;
                        "
                        :src="baseURL + '/file/get/' + item.photo"
                        height="180px"
                      />
                      <v-img
                        v-else
                        style="
                          width: 100%;
                          object-fit: contain;
                          cursor: pointer;
                        "
                        src="../../assets/images/no-image.png"
                        height="180px"
                        contain
                      >
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height ma-0"
                            align="center"
                            justify="center"
                          >
                            <v-progress-circular
                              indeterminate
                              color="#FF2323"
                            ></v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-flex> -->
                    <v-flex md12 text-center py-4>
                      <v-card rounded>
                        <v-layout wrap j text-center pa-5>
                          <v-flex
                            xs12
                            text-center
                            pt-1
                            style="font-size: 25px; color: #000000"
                          >
                            <span> Rs. </span> <span>{{ item.amount }} </span>
                          </v-flex>
                        </v-layout>
                      </v-card>
                    </v-flex>
                    <v-flex xs12>
                      <v-layout text-right>
                        <v-flex pt-2 px-1 xs6>
                          <v-btn
                            @click="(editdialog = true), editFunc(item)"
                            x-small
                            class="mr-2"
                            block
                            color="primary"
                          >
                            Edit
                          </v-btn>
                        </v-flex>

                        <v-flex pt-2 px-1 xs6 align-self-end>
                          <v-dialog v-model="item.delete" max-width="600px">
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                x-small
                                class="mr-2"
                                dark
                                block
                                v-on="on"
                                v-bind="attrs"
                                color="red"
                              >
                                Delete
                              </v-btn>
                            </template>
                            <v-card>
                              <v-card-title
                                >Are you sure you want to delete this
                                Offer?</v-card-title
                              >
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="blue darken-1"
                                  text
                                  @click="item.delete = false"
                                  >Cancel</v-btn
                                >
                                <v-btn
                                  color="blue darken-1"
                                  text
                                  @click="deleteItem(item)"
                                  >OK</v-btn
                                >
                                <v-spacer></v-spacer>
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>
          </div>
          <div v-else>
            <v-layout pt-15 justify-center fill-height wrap>
              <v-flex text-center xs12 lg12>
                <span style="font-size: 22px; letter-spacing: 1px">
                  No Data Found...
                </span>
              </v-flex>
            </v-layout>
          </div>
          <v-dialog v-model="editdialog" max-width="800px">
            <v-card>
              <v-card-title>
                <span class="headline">Edit Deal</span>
              </v-card-title>
              <v-card-text>
                <v-layout wrap>
                  <v-flex xs12>
                    <v-text-field
                      label="Banner Name"
                      v-model="editingitem.name"
                    >
                    </v-text-field>
                  </v-flex>
                </v-layout>

                <v-layout wrap pt-3>
                  <v-flex xs12 md6 pr-1>
                    <v-text-field
                      label=" Statring Price"
                      v-model="editingitem.priceFrom"
                    >
                    </v-text-field>
                  </v-flex>
                </v-layout>
                <!-- <v-layout wrap>
                  <v-flex xs12 md12 lg12>
                    <ImageComp
                      :singleImage="editingitem.offerImage"
                      :pageId="editingitem._id"
                      @stepper="winStepper"
                      :height="9"
                      :width="16"
                      :heading="'Upload offer Image '"
                      :componentType="'DealImage'"
                    />
                  </v-flex>
                </v-layout> -->
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="editdialog = false">
                  Close
                </v-btn>
                <v-btn color="blue darken-1" text @click="edit()"> Save </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
// import ImageComp from "@/components/Common/singleImage";

export default {
  components: {
    // ImageComp,
  },
  data() {
    return {
      editDialog: false,
      DealImage: null,
      SubcategoryList: [],

      isForDiscount: false,
      deals: [],
      productList: [],
      ServerError: false,
      widthOfCard: "250px",
      rot: 0,
      menu: false,
      menu1: false,
      menu3: false,
      menu4: false,
      menu5: false,
      menu6: false,
      menu7: false,
      menu8: false,
      products: [],
      offerData: {},

      formDataCover: new FormData(),
      offerImage: null,
      showSnackbar: false,
      msg: null,
      pages: 0,
      appLoading: false,
      currentPage: 1,
      totalData: 0,
      totalRows: 0,
      delete: false,
      dialogDelete: false,
      dialog: false,
      dialog1: false,
      editdialog: false,
      editingitem: [],
      offerList: [],
      data: [],
      addslider: false,
      imgId: "",
      rules: {
        required: (value) => !!value || "Required.",
        counter: (value) => value.length <= 20 || "Max 20 characters",
        num: (value) => (value < 100 && value >= 0) || "Must be between 0-100",
      },
      Rules: [(value) => !!value || "Required."],
      titleRule: [(v) => v.length < 50 || "Min 50 characters"],
      sellers: [],
      categoryList: [],
    };
  },

  mounted() {
    this.getData();
    this.getCategory();
    this.getProducts();
  },
  // watch: {
  //   rot() {
  //     if (this.rot > 360) this.rot = 0;
  //   },
  // },
  methods: {
    changeDealStatus(item) {
      this.appLoading = true;
      axios({
        url: "/grocery/delivery/offer/status/change",
        method: "post",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          id: item,
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.appLoading = false;
            this.showSnackbar = true;
            this.msg = response.data.msg;
            setTimeout(() => {
              this.getData();
            }, 2000);
          } else {
            this.appLoading = false;
            this.showSnackbar = true;
            this.msg = response.data.msg;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },

    editFunc(item) {
      this.editingitem.name = item.offerName;

      this.editingitem.priceFrom = item.amount;

      this.editingitem.offerImage = item.photo;
      this.editingitem.Id = item._id;
    },
    getProduct(sellerId) {
      console.log(sellerId);
      this.appLoading = true;
      axios({
        url: "/grocery/subcategory/list/" + sellerId,
        method: "get",
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.deals = response.data.data;
            this.totalCount = response.data.totalLength;
            // this.pages = response.data.pages;
            this.appLoading = false;
          } else {
            this.msg = response.data.msg;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    winStepper(window_data) {
      this.DealImage = window_data.selectedFiles;
      console.log(" this.DealImage===", this.DealImage);
    },
    getData() {
      this.appLoading = true;
      axios({
        url: "/grocery/delivery/offer/list",
        method: "get",
        headers: {
          token: localStorage.getItem("token"),
        },
        params: {
          limit: 50,
          page: this.currentPage,
        },
      })
        .then((response) => {
          this.offerList = response.data.offers;
          this.pages = Math.ceil(response.data.totalPages / 50);
          this.appLoading = false;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },

    getProducts() {
      // this.appLoading = true;
      axios({
        method: "post",
        url: "/grocery/admin/products/list",
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status == true) {
            {
              this.productList = response.data.product;

              // this.appLoading = false;
            }
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },

    getCategory() {
      this.appLoading = true;
      axios({
        method: "get",
        url: "/grocery/category/list/62b16b36fdd907192c69f476",
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status == true) {
            {
              this.categoryList = response.data.data;
              this.appLoading = false;
            }
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },

    getSubCategory(val) {
      this.appLoading = true;
      axios({
        method: "get",
        url: "/grocery/subcategory/list/" + val,
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status == true) {
            {
              this.SubcategoryList = response.data.data;
              this.appLoading = false;
            }
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },

    add() {
      this.appLoading = true;

      axios({
        url: "/grocery/delivery/offer/add",
        method: "POST",
        data: this.offerData,
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            // this.imgId = response.data.id;
            // if (this.DealImage != null) this.uploadImage(response.data.id);
            this.getData();
            this.msg = "Added Sucessfully";
            this.showSnackbar = true;
            Object.keys(this.offerData).forEach(
              (key) => (this.offerData[key] = null)
            );

            this.file = null;
            this.dialog = false;
          } else {
            this.msg = response.data.msg;
            this.showSnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    edit() {
      this.appLoading = true;

      var editData = {};
      editData["offerName"] = this.editingitem.name;
      editData["amount"] = this.editingitem.priceFrom;
      editData["id"] = this.editingitem.Id;

      axios({
        method: "POST",
        url: "/grocery/delivery/offer/edit",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: editData,
      })
        .then((response) => {
          this.appLoading = false;

          if (response.data.status) {
            this.editData = {};
            if (this.DealImage != null) this.uploadImage(response.data.id);
            this.editdialog = false;
            this.formDataCover = new FormData();
            this.msg = response.data.msg;
            this.showSnackbar = true;
            this.getData();
          } else {
            this.msg = response.data.msg;
            this.showSnackbar = true;
            this.formDataCover = new FormData();
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },

    deleteItem(r) {
      this.appLoading = true;
      axios({
        url: "/grocery/delivery/offer/delete",
        method: "POST",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          id: r._id,
        },
      })
        .then((response) => {
          this.delete = false;
          this.appLoading = false;
          if (response.data.status) {
            this.msg = "Delete Sucessfully";
            this.showSnackbar = true;
            this.getData();
          } else {
            this.msg = response.data.msg;
            this.showSnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    dialogclose() {
      this.link = null;
      this.dialog = false;
    },

    uploadImage(id) {
      let formData = new FormData();
      formData.append("id", id);
      formData.append("offerImage", this.DealImage);
      axios({
        method: "POST",
        url: "/grocery/deliveryoffer/upload/icon",
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.getData();
            this.offerImage = null;
            this.showSnackbar = true;
            this.msg = "Uploaded Successfully";
            this.dialog = false;
            this.DealImage = null;
          } else {
            this.msg = "Can't Update";
            this.showSnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },

    formatDate(item) {
      var dt = new Date(item);
      var year = dt.getFullYear();
      dt = dt.toString();
      var strTime = dt.slice(4, 10) + " " + year;
      return strTime;
    },
    formatTime(item) {
      if (!item) return;
      var hours = Number(item.split(":")[0]);
      var minutes = Number(item.split(":")[1]);
      var ampm = hours >= 12 ? "PM" : "AM";
      hours = hours % 12;
      hours = hours ? hours : 12;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime = hours + ":" + minutes + " " + ampm;
      return strTime;
    },
  },
};
</script>